import { TextField } from "@king-ict/eupisi-ui/components";
import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import { ProgramCodeBook } from "../../models/Program";
import { ProgramRequestData } from "../../models/ProgramRequest";
import styles from "./ProgramRequestEdit.module.scss";

interface Props {
  programData: ProgramCodeBook;
}

/** 
 * Renders 4 rows of readonly qualification, hkoLevel,
 * sector, and profession information.
 */
export function MiddleSchoolProgramInfo({
  programData,
}: Props) {
  const { t } = useTranslation();

  return (
    <>
      <Row className={styles.rowSpacing}>
        <Col md={4}>
          <TextField
            plaintext
            label={t("request.qualification")}
            readonly
            value={programData.qualificationType}
          />
        </Col>
        <Col md={4}>
          <TextField
            plaintext
            label={t("request.hkoLevel")}
            readonly
            value={programData.hkoLevelName}
          />
        </Col>
      </Row>
      <Row className={styles.rowSpacing}>
        <Col md={4}>
          <TextField
            plaintext
            label={t("common.qualification")}
            readonly
            value={programData.qualificationName}
          />
        </Col>
      </Row>
      <Row className={styles.rowSpacing}>
        <Col md={4}>
          <TextField
            plaintext
            label={t("common.educationSector")}
            readonly
            value={programData.educationSectorName}
          />
        </Col>
        <Col md={4}>
          <TextField
            plaintext
            label={t("common.educationSubSector")}
            readonly
            value={programData.educationSubSectorName}
          />
        </Col>
      </Row>
      <Row className={styles.rowSpacing}>
        <Col md={4}>
          <TextField
            plaintext
            label={t("common.profession")}
            readonly
            value={programData.professionName}
          />
        </Col>
      </Row>
    </>
  )
}